import { render, staticRenderFns } from "./PluginExplainerView.vue?vue&type=template&id=9f7ce7c0&scoped=true"
import script from "./PluginExplainerView.vue?vue&type=script&lang=js"
export * from "./PluginExplainerView.vue?vue&type=script&lang=js"
import style0 from "./PluginExplainerView.vue?vue&type=style&index=0&id=9f7ce7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7ce7c0",
  null
  
)

export default component.exports